import {SET_TIMELINE_FIELD} from '../Actions/TimeLine.action';
import {customFormatDate} from '../Core/date';


const defaultState = {
	minTime: '',
	maxTime: '',
	lastTime: '',
	selectedCalendar: window.__appointment.preloadState.shop ? customFormatDate(window.__appointment.preloadState.shop.firstDateWorking) : customFormatDate(new Date()),
	serviceDuration: 0
};

export const timelines = (state = defaultState, action) => {
	const {payload} = action;
	if (!payload) return state;
	switch (action.type) {
		case SET_TIMELINE_FIELD: 
			let newState = {...state},
				{listField} = payload;
				listField.forEach(e => {
				newState = {
					...newState,
					[e.key] : e.value
				}
			})
			return {
				...newState
			}
		default:
			return state;
	}
}